export const linealregressionsample = `[[32,53,61,47,59,55,52,39,48,52,45,54,44,58,56,48,44,60,45,38,66,65,47,41,51,59,57,63,46,50,52,35,42,58,57,45,61,33,36,37,44,43,50,43,62,32,40,53,33,64,38,44,40,41,51,55,41,62,49,41,41,50,52,50,33,39,56,57,60,35,31,53,46,43,70,44,57,36,55,38,56,56,34,59,57,54,51,50,44,38,32,53,68,46,68,50,49,50,48,25],[31,68,62,71,87,78,79,59,75,71,55,82,62,75,81,60,82,97,48,56,83,118,57,51,75,74,95,95,79,83,63,41,76,96,74,66,77,50,62,60,52,58,82,61,115,45,54,87,52,93,80,65,65,65,73,71,79,86,84,59,61,69,86,59,69,44,85,95,70,52,50,63,72,57,104,86,91,55,79,44,80,83,55,77,99,79,69,69,73,61,67,85,114,90,97,81,72,85,66,53]]`
export const logisticregressionsample = `[[0.5, 0.75, 1, 1.25, 1.5, 1.75, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 4, 4.25, 4.5, 4.75, 5, 5.5],[0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1]]`
export const multipleArrays3 = `[[3, 3, 3, 4, 6, 6, 7],[7, 4, 7, 8, 7, 5, 9],[1, 4, 6, 4, 5, 6, 8]]`
export const datamultiScattersample = `[[2,3,6,4,5,6,6,8,9,7,10,12,8,10,11,13,14,15,14,16],[0.5, 0.75, 1, 1.25, 1.5, 1.75, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 4, 4.25, 4.5, 4.75, 5, 5.5],[0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1],["03/15/2017 12:00","03/15/2017 18:00","03/16/2017 00:00","03/16/2017 06:00","03/16/2017 12:00","03/16/2017 18:00","03/17/2017 00:00","03/17/2017 06:00"],[2,4,6,4,10,3,3,7]]`
export const anomaly = `[["03/15/2017 06:00", "03/15/2017 12:00", "03/15/2017 18:00", "03/16/2017 00:00", "03/16/2017 06:00", "03/16/2017 12:00", "03/16/2017 18:00", "03/17/2017 00:00", "03/17/2017 06:00", "03/17/2017 12:00", "03/17/2017 18:00", "03/18/2017 00:00", "03/18/2017 06:00", "03/18/2017 12:00", "03/18/2017 18:00", "03/19/2017 00:00", "03/19/2017 06:00", "03/19/2017 12:00", "03/19/2017 18:00", "03/20/2017 00:00", "03/20/2017 06:00", "03/20/2017 12:00", "03/20/2017 18:00", "03/21/2017 00:00", "03/21/2017 06:00", "03/21/2017 12:00", "03/21/2017 18:00", "03/22/2017 00:00", "03/22/2017 06:00", "03/22/2017 12:00", "03/22/2017 18:00", "03/23/2017 00:00", "03/23/2017 06:00", "03/23/2017 12:00", "03/23/2017 18:00", "03/24/2017 00:00", "03/24/2017 06:00", "03/24/2017 12:00", "03/24/2017 18:00", "03/25/2017 00:00", "03/25/2017 06:00", "03/25/2017 12:00", "03/25/2017 18:00", "03/26/2017 00:00", "03/26/2017 06:00", "03/26/2017 12:00", "03/26/2017 18:00", "03/27/2017 00:00", "03/27/2017 06:00", "03/27/2017 12:00", "03/27/2017 18:00", "03/28/2017 00:00", "03/28/2017 06:00", "03/28/2017 12:00", "03/28/2017 18:00", "03/29/2017 00:00", "03/29/2017 06:00", "03/29/2017 12:00", "03/29/2017 18:00", "03/30/2017 00:00", "03/30/2017 06:00", "03/30/2017 12:00", "03/30/2017 18:00"],[2,4,6,10,3,3,7,9,2,5,7,10,2,3,7,9,3,4,6,10,1,5,8,8,2,5,8,9,2,4,7,9,1,3,3.5,9,1,3,7,9,2,3,7,9,3,4,6,9,2,4,7,10,1,4,7,8,2,4,8,9,2,4,6]]`;
export const histogram = `[[0,2,2,4,4,9,9,11,11,14,14,16,16,18,18,20,20]]`
export const databar = `[{
    "date": "03/29/2017 10:00",
    "values": [2, 1, 3]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [3, 3, 1]
}, {
    "date": "03/29/2017 13:00",
    "values": [4, 5, 3]
}]`;
export const multilinealregressionsample = `[[2104,1600,2400,1416,3000,1985,1534,1427,1380,1494,1940,2000,1890,4478,1268,2300,1320,1236,2609,3031,1767,1888,1604,1962,3890,1100,1458,2526,2200,2637,1839,1000,2040,3137,1811,1437,1239,2132,4215,2162,1664,2238,2567,1200,852,1852,1203],[3,3,3,2,4,4,3,3,3,3,4,3,3,5,3,4,2,3,4,4,3,2,3,4,3,3,3,3,3,3,2,1,4,3,4,3,3,4,4,4,2,3,4,3,2,4,3],[399900,329900,369000,232000,539900,299900,314900,198999,212000,242500,239999,347000,329999,699900,259900,449900,299900,199900,499998,599000,252900,255000,242900,259900,573900,249900,464500,469000,475000,299900,349900,169900,314900,579900,285900,249900,229900,345000,549000,287000,368500,329900,314000,299000,179900,299900,239500]]`
export const multillogisticregressionsample = `[[1,2,3,4,5,4,5,6,5,6,7,8,7,8,8,9,8,9],[3,4,3,4,3,4,5,4,5,4,5,6,7,7,8,7,8,7],[2,5,6,3,5,4,3,4,2,7,6,8,5,6,7,8,5,4],[0,1,1,1,0,1,1,1,0,1,1,0,1,1,0,1,1,1]]`

export const dataDonut = `[{
    "title": "Android",
    "value": 40
}, {
    "title": "Windows",
    "value": 20
}, {
    "title": "Print",
    "value": 20
}, {
    "title": "Other",
    "value": 20
}]`;

export const anomalyFinal = `[{"date": "03/15/2017 06:00", 
            "value": 2
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
                "date": "03/15/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/16/2017 00:00", 
                "value": 10
          }, { 
                "date": "03/16/2017 06:00", 
                "value": 3 
          }, { 
                "date": "03/16/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/16/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/17/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/17/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/17/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/17/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/18/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/18/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/18/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/18/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/19/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/19/2017 06:00", 
                "value": 3 
          }, { 
                "date": "03/19/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/19/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/20/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/20/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/20/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/20/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/21/2017 00:00", 
                "value": 8 
          }, { 
                "date": "03/21/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/21/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/21/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/22/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/22/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/22/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/22/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/23/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/23/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/23/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/23/2017 18:00", 
                "value": 3.5 
          }, { 
                "date": "03/24/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/24/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/24/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/24/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/25/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/25/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/25/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/25/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/26/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/26/2017 06:00", 
                "value": 3 
          }, { 
                "date": "03/26/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/26/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/27/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/27/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/27/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/27/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/28/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/28/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/28/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/28/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/29/2017 00:00", 
                "value": 8 
          }, { 
                "date": "03/29/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/29/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/29/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/30/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/30/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/30/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/30/2017 18:00", 
                "value": 6 
          }]`;
  export const anomalytest = `[{"date": "03/15/2017 06:00", 
            "value": 2
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
                "date": "03/15/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/16/2017 00:00", 
                "value": 10
          }, { 
                "date": "03/16/2017 06:00", 
                "value": 3 
          }, { 
                "date": "03/16/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/16/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/17/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/17/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/17/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/17/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/18/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/18/2017 06:00", 
                "value": 8 
          }, { 
                "date": "03/18/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/18/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/19/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/19/2017 06:00", 
                "value": 9 
          }, { 
                "date": "03/19/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/19/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/20/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/20/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/20/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/20/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/21/2017 00:00", 
                "value": 1 
          }, { 
                "date": "03/21/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/21/2017 12:00", 
                "value": 5 
          }, { 
                "date": "03/21/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/22/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/22/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/22/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/22/2017 18:00", 
                "value": 3 
          }, { 
                "date": "03/23/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/23/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/23/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/23/2017 18:00", 
                "value": 3.5 
          }, { 
                "date": "03/24/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/24/2017 06:00", 
                "value": 8 
          }, { 
                "date": "03/24/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/24/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/25/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/25/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/25/2017 12:00", 
                "value": 3 
          }, { 
                "date": "03/25/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/26/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/26/2017 06:00", 
                "value": 3 
          }, { 
                "date": "03/26/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/26/2017 18:00", 
                "value": 6 
          }, { 
                "date": "03/27/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/27/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/27/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/27/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/28/2017 00:00", 
                "value": 10 
          }, { 
                "date": "03/28/2017 06:00", 
                "value": 1 
          }, { 
                "date": "03/28/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/28/2017 18:00", 
                "value": 7 
          }, { 
                "date": "03/29/2017 00:00", 
                "value": 8 
          }, { 
                "date": "03/29/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/29/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/29/2017 18:00", 
                "value": 8 
          }, { 
                "date": "03/30/2017 00:00", 
                "value": 9 
          }, { 
                "date": "03/30/2017 06:00", 
                "value": 2 
          }, { 
                "date": "03/30/2017 12:00", 
                "value": 4 
          }, { 
                "date": "03/30/2017 18:00", 
                "value": 6 
          }]`;


// WEBPACK FOOTER //
// ./src/samples/data/samples.js